import { AnimationUtils } from '../../thirdparty/three/imports';
import { AnimationClip3D } from './AnimationClip3D';

export class AnimationUtils3D
{
    static makeClipAdditive(targetClip: AnimationClip3D, referenceFrame?: number, referenceClip?: AnimationClip3D, fps?: number)
    {
        const animationClip = AnimationUtils.makeClipAdditive(targetClip._animationClip, referenceFrame, referenceClip?._animationClip, fps);

        return AnimationClip3D.get(animationClip);
    }

    static subclip(sourceClip: AnimationClip3D, name: string, startFrame: number, endFrame: number, fps?: number)
    {
        const animationClip = AnimationUtils.subclip(sourceClip._animationClip, name, startFrame, endFrame, fps);

        return AnimationClip3D.get(animationClip);
    }
}
